import { FC } from 'react';
import {Card, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {ConsumerUserAccount, ConsumerUserAccountState, ConsumerUserFull} from '@interfaces/consumer/users';
import { useLocalizedBlock } from '@services/hooks';
import {AccountActions} from './details';
import {FalconCardHeader} from "@components/falcon/common";
import AdvanceTableProvider from "@components/falcon/common/tables/context";
import {AdvanceTable} from "@components/falcon/common/tables";
import {useTable} from "@hooks/tableHooks";
import {ColumnDef} from "@tanstack/react-table";
import {fromUtcDate} from "@services/helpers";
import {useLoginServers} from "@hooks/selectors/consumer/project.selectors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface ConsumerUserDetailsProps {
    user: ConsumerUserFull;
}

const ConsumerUserDetails: FC<ConsumerUserDetailsProps> = ({ user }) => {

    const lang = useLocalizedBlock('consumer.user.main');
    const loginServers = useLoginServers();

    return (
        <>
            {loginServers.map((login) => {
                const accounts = user.accounts.filter(acc => acc.loginId === login.id);
                return (
                    <Card className="h-100 mb-3" key={login.id}>
                        <FalconCardHeader
                            title={login.name}
                            titleTag="h6"
                            className="py-2"
                            light
                        />
                        <Card.Body className="position-relative pb-0 pt-0">
                            <AccountsList accounts={accounts} />
                        </Card.Body>
                    </Card>
                )
            })}
        </>
    )
}

interface AccountsListProps {
    accounts: ConsumerUserAccount[];
}

const columns: ColumnDef<ConsumerUserAccount>[] = [
    {
        accessorKey: 'name',
        header: 'Логин',
        cell: ({row}) => row.original.name
    },
    {
        accessorKey: 'innerId',
        header: 'Id',
        cell: ({row}) => row.original.innerId
    },    
    {
        accessorKey: 'createTime',
        header: 'Дата создания',
        cell: ({row: {original}}) => (
            <div>                
                {fromUtcDate(original.createTime).format('lll')}
                {original.state === ConsumerUserAccountState.Creating && (
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip style={{position: 'fixed'}}>Создается</Tooltip>}
                    >
                        <span className="ms-2">
                            <FontAwesomeIcon icon="exclamation-triangle" className="text-warning" />
                        </span>
                    </OverlayTrigger>
                )}
            </div>
        )
    },
    {
        accessorKey: 'actions',
        header: '',
        enableSorting: false,
        meta: {
            headerProps: {
                scope: 'col',
            },
            cellProps: {
                className: "text-end"
            }
        },
        cell: ({row}) => (
            <AccountActions account={row.original}/>
        )
    }
]

const AccountsList: FC<AccountsListProps> = ({accounts}) => {

    const table = useTable({
        columns
    }, accounts);

    return (
        <AdvanceTableProvider table={table}>
            <div className="mx-ncard">
                <AdvanceTable
                    headerClassName="bg-200 text-nowrap align-middle font-sans-serif"
                    rowClassName="align-middle white-space-nowrap fw-semibold"
                    emptyText="Нет аккаунтов"
                    tableProps={{
                        className: 'fs-10 mb-0'
                    }}
                />
            </div>
        </AdvanceTableProvider>
    )
}

export default ConsumerUserDetails;